import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-cog.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const CogIcon = createSvgIcon(<Icon />, 'CogIcon');
